/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pink_Male_Puma_AgreeInputs */

const fr_pink_male_puma_agree = /** @type {(inputs: Pink_Male_Puma_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non notifié`)
};

/**

* @param {Pink_Male_Puma_AgreeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pink_male_puma_agree = /** @type {((inputs?: Pink_Male_Puma_AgreeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pink_Male_Puma_AgreeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pink_male_puma_agree(inputs)
});